function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("circle", {
  opacity: 0.8,
  cx: 22,
  cy: 22,
  r: 22,
  fill: "#F7F7F7"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M22.6 12a.6.6 0 10-1.2 0v9.4H12a.6.6 0 100 1.2h9.4V32a.6.6 0 101.2 0v-9.4H32a.6.6 0 100-1.2h-9.4V12z",
  fill: "#333"
});

function SvgCustomCursorPlus(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none"
  }, props), _ref, _ref2);
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDQiIGhlaWdodD0iNDQiIHZpZXdCb3g9IjAgMCA0NCA0NCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGNpcmNsZSBvcGFjaXR5PSIwLjgiIGN4PSIyMiIgY3k9IjIyIiByPSIyMiIgZmlsbD0iI0Y3RjdGNyIvPgo8cGF0aCBkPSJNMjIuNiAxMS45OTk5QzIyLjYgMTEuNjY4NSAyMi4zMzE0IDExLjM5OTkgMjIgMTEuMzk5OUMyMS42Njg2IDExLjM5OTkgMjEuNCAxMS42Njg1IDIxLjQgMTEuOTk5OVYyMS4zOTk5SDEyQzExLjY2ODYgMjEuMzk5OSAxMS40IDIxLjY2ODUgMTEuNCAyMS45OTk5QzExLjQgMjIuMzMxMyAxMS42Njg2IDIyLjU5OTkgMTIgMjIuNTk5OUgyMS40VjMxLjk5OTlDMjEuNCAzMi4zMzEzIDIxLjY2ODYgMzIuNTk5OSAyMiAzMi41OTk5QzIyLjMzMTQgMzIuNTk5OSAyMi42IDMyLjMzMTMgMjIuNiAzMS45OTk5VjIyLjU5OTlIMzJDMzIuMzMxNCAyMi41OTk5IDMyLjYgMjIuMzMxMyAzMi42IDIxLjk5OTlDMzIuNiAyMS42Njg1IDMyLjMzMTQgMjEuMzk5OSAzMiAyMS4zOTk5SDIyLjZWMTEuOTk5OVoiIGZpbGw9IiMzMzMzMzMiLz4KPC9zdmc+Cg==";
export { SvgCustomCursorPlus as ReactComponent };